import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Home } from 'lucide-react';
import { Button } from '../ui/button';

export function CourseListView({ courses }) {
  return (
    <div className="p-8" data-testid="my-courses-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
            My Courses
          </h1>
          <p className="text-[#71717A]">Access your enrolled courses and video lessons</p>
        </div>
        <Link to="/">
          <Button variant="outline" className="border-[#27272A] text-[#A1A1AA]" data-testid="back-home-btn">
            <Home className="w-4 h-4 mr-2" /> Back to Home
          </Button>
        </Link>
      </div>

      {courses.length > 0 ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map(course => (
            <div 
              key={course.id}
              className="bg-[#141417] border border-[#27272A] rounded-md overflow-hidden hover:border-[#007AFF]/50 transition-colors"
              data-testid={`enrolled-course-${course.id}`}
            >
              <div className="relative h-40">
                <img src={course.image_url} alt={course.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#141417] to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#27272A]">
                  <div 
                    className="h-full bg-[#007AFF]" 
                    style={{ width: `${course.progress_percent || 0}%` }}
                  ></div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
                  {course.title}
                </h3>
                <p className="text-[#71717A] text-sm mb-4 line-clamp-2">{course.description}</p>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-[#A1A1AA] text-sm">
                    {course.completed_lessons || 0}/{course.total_lessons || course.lessons?.length || 0} lessons
                  </span>
                  <span className="text-[#007AFF] font-mono">{course.progress_percent || 0}%</span>
                </div>
                <Link to={`/dashboard/courses/${course.id}`}>
                  <Button className="btn-primary w-full" data-testid={`view-course-${course.id}`}>
                    {course.progress_percent > 0 ? 'Continue Learning' : 'Start Course'}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-[#141417] border border-[#27272A] rounded-md p-12 text-center">
          <Lock className="w-16 h-16 text-[#71717A] mx-auto mb-4" />
          <h2 className="text-xl font-bold text-white mb-2">No Courses Yet</h2>
          <p className="text-[#71717A] mb-6">You haven't enrolled in any courses yet. Start your trading journey today!</p>
          <Link to="/#courses">
            <Button className="btn-primary" data-testid="browse-courses-btn">Browse Courses</Button>
          </Link>
        </div>
      )}
    </div>
  );
}
